import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';

import { IconType } from 'react-icons/lib';

import {
  Container,

} from './styles';



import { useAuth } from '../../hooks/Auth';

import { useModal } from '../../hooks/Modal';

import { usePages } from '../../hooks/Pages';
import { useLanguage } from '../../hooks/Language';

import api from '../../services/api';
import { hash, urlWebsite } from '../../config';

import { loadFromJson } from '../../utils/loadFromJson';
import LeiteEmPo from '../ComoEFeito/modules/LeiteEmPo';

interface IMenu {
  title: string;
  target: string;
  targetID: string;
  fluid: number;
  external: number;
  status: number;
}

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Vitalidade: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const data = [

    { img_style: { width: '45px' }, icon: '/apoio/pro/energia.png', title: 'ENERGIA PARA SUA VIDA', description: 'Cada porção do leite em pó CCGL é enriquecida com nutrientes (magnésio, vitamina B1, vitamina B3, vitamina B5) que estão relacionados ao metabolismo de energia. Ou seja, ajudam a manter o funcionamento normal do seu metabolismo de energia, acompanhando seu ritmo acelerado!' },
    {
      img_style: { width: '70px' }, icon: '/apoio/flexibilidade.png', title: 'FLEXIBILIDADE NA ROTINA', description: 'A sua vida é uma jornada movimentada e sabemos que sua nutrição deve ser tão adaptável quanto você. Nosso leite em pó é a solução prática e versátil para suas necessidades nutricionais, seja em casa, na academia ou no trânsito. Apenas um shake, misturando o leite em pó com água, e você está pronto para conquistar o dia.'
    },
    { img_style: { width: '70px' }, icon: '/apoio/pro/recuperacao.png', title: 'RECUPERAÇÃO RÁPIDA PARA O SEU DIA A DIA', description: 'Sabemos que a recuperação é crucial para sustentar uma vida ativa. Com uma mistura equilibrada de proteínas de qualidade e outros nutrientes, nosso leite em pó auxilia na recuperação muscular, garantindo que você esteja pronto para enfrentar cada desafio, mantendo o equilíbrio entre trabalho, diversão, esporte e bem-estar.' },
    { img_style: { width: '60px' }, icon: '/apoio/nutrido.png', title: 'MANTENHA-SE NUTRIDO, MESMO EM MOVIMENTO', description: 'Sabemos que a recuperação é crucial para sustentar uma vida ativa. Com uma mistura equilibrada de proteínas de qualidade e outros nutrientes, nosso leite em pó auxilia na recuperação muscular, garantindo que você esteja pronto para enfrentar cada desafio, mantendo o equilíbrio entre trabalho, diversão, esporte e bem-estar.' },
    { img_style: { width: '50px' }, icon: '/apoio/multitarefa.png', title: 'PARA OS MULTITAREFADOS E OS ACELERADOS', description: 'Seja você um multitarefa profissional, um entusiasta do fitness com uma agenda lotada ou alguém que simplesmente abraça o caos controlado da vida, O LEITE EM PÓ PROTEICO CCGL ESTÁ AQUI PARA SER O APOIO ESSENCIAL NO SEU DIA A DIA.' },

  ]
  const currentData = data?.[currentIndex] || {};

  return (<>


    <Container className='gap-bg column  ' style={{ minHeight: '80vh', background: 'none', zIndex: 900 }}>

      <div className='row full-width fadeIn '>
        <img loading='lazy' src='/apoio/vitalidade/ccgl.png' className='max-400' />
      </div>
      <div className='max-1400 gap-bg column fadeIn ' style={{ marginTop: '50px' }}>
        <img loading='lazy' src='/apoio/pro/imagens-pagina4.png' className='max-1400 computerOnly' />
        <img loading='lazy' src='/apoio/pro/pag4-mobile.png' className='max-1400 mobileOnly' />





        <div className='row full-width fadeIn '>
          <img loading='lazy' src='/apoio/vitalidade/muscularv2.png' className='max-1000' />


        </div>
        <p className='contentParagraphSimple text-center max-1200'>
          Caro amante de um estilo de vida ativo. Se a sua vida é uma constante dança entre os compromissos diários, o trabalho, os treinos e a agitação constante, temos a solução ideal para manter sua energia em alta e nutrir seu corpo nos momentos mais movimentados. Apresentamos o nosso Leite em Pó Proteico CCGL -  a resposta para você, que não para!
        </p>
        <div className='column computerOnlyFlex'>

          {data?.map(item => {
            return <div className='row fadeIn   row-start row-to-column max-1200 gap-md pad-sm' style={{ alignItems: 'flex-start' }}>
              <div style={{ width: '70px', minWidth: '70px', display: 'flex', marginTop: '7px', alignItems: 'flex-start', justifyContent: 'center' }}><img loading='lazy' className='max-100' style={{ ...item?.img_style }} src={item?.icon} /></div>
              <p className='contentParagraphSimple text-left max-1200'>
                <strong className='color2'>{item?.title}</strong> <br />
                <p dangerouslySetInnerHTML={{ __html: item?.description }} />  </p>
            </div>


          })}

        </div>

        <div className='mobileOnlyFlex column'>

          <div className='row gap-xs'>

            {data?.map((item, index) => {

              return <div style={{ borderRadius: '7.5px', width: '60px', height: '60px', display: 'flex', justifyContent: 'center', alignItems: 'center' }} className={`pad-xs fadeIn  ${index === currentIndex ? 'background1 ' : 'none'}`}>
                <img loading='lazy' onClick={() => setCurrentIndex(index)} style={{ maxHeight: '50px', width: 'auto' }} src={item?.icon} /></div>
            })}


          </div>

          <div key={currentData?.title} className='row fadeIn  row-start rcolumn max-1000 gap-md pad-sm'>
            <p className='contentParagraphSimple text-left max-1000'>
              <strong className='color2'>{currentData?.title}</strong> <br />
              <p  > {currentData?.description}</p></p>
          </div>


        </div>


      </div>



    </Container>

  </>
  );
};
export default Vitalidade;
